export default __webpack_public_path__ + "static/media/showcase-vouchers.af54fd69.jpg";